import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "row q-pa-sm" };
const _hoisted_4 = {
    key: 0,
    class: "col-12 col-md-6"
};
const _hoisted_5 = { class: "q-pa-md" };
const _hoisted_6 = { class: "q-pb-lg" };
const _hoisted_7 = { class: "entry-check-table" };
const _hoisted_8 = { class: "text-right" };
const _hoisted_9 = { class: "text-right" };
const _hoisted_10 = { class: "table-scroll" };
const _hoisted_11 = { class: "bordered responsive-table" };
const _hoisted_12 = {
    "data-title": "対象年月",
    class: "text-center"
};
const _hoisted_13 = {
    "data-title": "請求内容",
    class: "text-center"
};
const _hoisted_14 = {
    "data-title": "税",
    class: "text-center"
};
const _hoisted_15 = {
    "data-title": "請求額",
    class: "text-right"
};
const _hoisted_16 = {
    "data-title": "入金状況",
    class: "text-center"
};
const _hoisted_17 = {
    "data-title": "入金額",
    class: "text-right"
};
const _hoisted_18 = { class: "text-center" };
const _hoisted_19 = {
    "data-title": "請求内容",
    class: "text-center"
};
const _hoisted_20 = {
    "data-title": "税",
    class: "text-center"
};
const _hoisted_21 = {
    "data-title": "請求額",
    class: "text-right"
};
const _hoisted_22 = {
    "data-title": "入金状況",
    class: "text-center"
};
const _hoisted_23 = {
    "data-title": "入金額",
    class: "text-right"
};
const _hoisted_24 = {
    "data-title": "入金区分",
    class: "text-center"
};
const _hoisted_25 = {
    "data-title": "請求先",
    class: "text-center"
};
const _hoisted_26 = {
    key: 0,
    class: "q-ma-sm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_BukenRoomList = _resolveComponent("BukenRoomList");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    { itemId: _ctx.PageID.seikyu }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    (_ctx.myPageStore.isMultipleKeiyaku)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createVNode(_component_BukenRoomList)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "table-caption" }, "過入金・未払い金情報", -1)),
                                        _createElementVNode("table", _hoisted_7, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[1] || (_cache[1] = _createElementVNode("th", null, "過入金残高", -1)),
                                                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.data.azukariZandaka), 1),
                                                    _cache[2] || (_cache[2] = _createElementVNode("th", null, "未払い金合計", -1)),
                                                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.data.mishukinTotal), 1)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "table-caption" }, "お支払い状況（保証会社・信販会社を利用している場合は、家賃引落日より先に家賃の引落しが出来ていなくても弊社にて入金処理を行います。引落し日の前日までにご自身の口座への入金をお願いします）", -1)),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("table", _hoisted_11, [
                                            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "対象年月"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "ご請求内容"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "税"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "ご請求額"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "支払状況"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "ご入金額"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "入金区分"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" }, "ご請求先"),
                                                    _createElementVNode("th", { class: "text-center th-sticky" })
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.seikyuMeisaiList, (meisai, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("td", _hoisted_12, _toDisplayString(meisai.keijoYm), 1),
                                                            _createElementVNode("td", _hoisted_13, _toDisplayString(meisai.dataSakuseiKd), 1),
                                                            _createElementVNode("td", _hoisted_14, _toDisplayString(meisai.seikTaxKb), 1),
                                                            _createElementVNode("td", _hoisted_15, _toDisplayString(meisai.seikTotal), 1),
                                                            _createElementVNode("td", _hoisted_16, _toDisplayString(meisai.nkinSumiKb), 1),
                                                            _createElementVNode("td", _hoisted_17, _toDisplayString(meisai.nkinTotal), 1),
                                                            _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-center" }, null, -1)),
                                                            _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                                            _createElementVNode("td", _hoisted_18, [
                                                                _createVNode(_component_q_btn, {
                                                                    class: "btn-toggele-arrow",
                                                                    icon: meisai.openDetailFlg ? 'expand_less' : 'expand_more',
                                                                    color: "positive",
                                                                    onClick: ($event) => (meisai.openDetailFlg = !meisai.openDetailFlg)
                                                                }, null, 8, ["icon", "onClick"])
                                                            ])
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meisai.seikyuMeisaiDetailList, (meisaiDetail, index) => {
                                                            return _withDirectives((_openBlock(), _createElementBlock("tr", {
                                                                class: "hide-row bg-light",
                                                                key: index
                                                            }, [
                                                                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-center" }, null, -1)),
                                                                _createElementVNode("td", _hoisted_19, _toDisplayString(meisaiDetail.kamkName), 1),
                                                                _createElementVNode("td", _hoisted_20, _toDisplayString(meisaiDetail.seikTaxKb), 1),
                                                                _createElementVNode("td", _hoisted_21, _toDisplayString(meisaiDetail.seikTotal), 1),
                                                                _createElementVNode("td", _hoisted_22, _toDisplayString(meisaiDetail.nkinSumiKb), 1),
                                                                _createElementVNode("td", _hoisted_23, _toDisplayString(meisaiDetail.nkinTotal), 1),
                                                                _createElementVNode("td", _hoisted_24, _toDisplayString(meisaiDetail.nkinKb), 1),
                                                                _createElementVNode("td", _hoisted_25, _toDisplayString(meisaiDetail.userName), 1),
                                                                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "text-center" }, null, -1))
                                                            ])), [
                                                                [_vShow, meisai.openDetailFlg]
                                                            ]);
                                                        }), 128))
                                                    ], 64));
                                                }), 128))
                                            ])
                                        ]),
                                        (!_ctx.data.seikyuMeisaiList || _ctx.data.seikyuMeisaiList.length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                _createVNode(_component_q_icon, {
                                                    name: "warning",
                                                    class: "q-table__bottom-nodata-icon"
                                                }),
                                                _cache[9] || (_cache[9] = _createTextVNode(" 請求データがありません。 ", -1))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
